/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {ApiService} from '@/services/http/api';
import {AuthService} from '@/services/http/auth';
import {HttpFactory} from '@/services/http/factory';
import {CmsService} from '@/services/http/cms';

/**
 * Generate http items that we require for this application.
 *
 * Note: this is using the Http factory to generate items.
 */
const api: ApiService = HttpFactory.createInstance(ApiService);
const auth: AuthService = HttpFactory.createInstance(AuthService);
const cms: CmsService = HttpFactory.createInstance(CmsService);
export {
    api,
    auth,
    cms,
};
